import "./DeleteDialog.scss";
import Dialog from "../../../dialogs/Dialog";

export default function DeleteDialog({ setOpen, isOpen, onConfirm }) {

    const handleClose = () => {
        setOpen(false);
    }


    const handleConfirm = () => {
        onConfirm();
        handleClose();
    };

    return (
        <Dialog 
        title={"Upozornenie"}
        isOpen={isOpen}
        onClose={handleClose}
        onConfirm={handleConfirm}
        className={"AkcUiDesigner"}
        level={1}
        width={window.innerWidth / 3}
        >
            <div className="deleteDialog-body">
                Tieto zmeny nebudete môcť vrátiť späť.
            </div>
        </Dialog >
    )
}
